module.exports = __webpack_public_path__ + "img/produceResource.deaf9059.png";